import React from 'react'

export default function LegendIcon({ className, size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="32" cy="32" r="30" fill="url(#legend-bg)" opacity="0.2" />
      <defs>
        <linearGradient id="legend-bg" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#667eea" />
          <stop offset="100%" stopColor="#764ba2" />
        </linearGradient>
        <linearGradient id="legend-main" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#ffd89b" />
          <stop offset="100%" stopColor="#19547b" />
        </linearGradient>
        <linearGradient id="legend-gold" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#f7971e" />
          <stop offset="100%" stopColor="#ffd200" />
        </linearGradient>
        <radialGradient id="legend-glow">
          <stop offset="0%" stopColor="#ffd200" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#f7971e" stopOpacity="0" />
        </radialGradient>
      </defs>
      
      {/* Сияние вокруг */}
      <circle cx="32" cy="32" r="24" fill="url(#legend-glow)" opacity="0.3" />
      
      {/* Основная звезда легенды */}
      <path
        d="M32 12 L36 26 L50 28 L40 38 L43 52 L32 45 L21 52 L24 38 L14 28 L28 26 Z"
        fill="url(#legend-gold)"
        stroke="url(#legend-main)"
        strokeWidth="1.5"
        opacity="0.95"
      />
      
      {/* Внутренняя звезда */}
      <path
        d="M32 20 L34 28 L42 29 L37 34 L39 42 L32 37 L25 42 L27 34 L22 29 L30 28 Z"
        fill="url(#legend-main)"
        opacity="0.7"
      />
      
      {/* Центральный кристалл */}
      <circle cx="32" cy="32" r="5" fill="url(#legend-gold)" opacity="0.9" />
      <circle cx="32" cy="32" r="3" fill="#ffd200" opacity="0.95" />
      
      {/* Лучи сияния */}
      <g opacity="0.6">
        <path d="M32 8 L33 14 L31 14 Z" fill="url(#legend-gold)" />
        <path d="M32 50 L33 56 L31 56 Z" fill="url(#legend-gold)" />
        <path d="M8 32 L14 33 L14 31 Z" fill="url(#legend-gold)" />
        <path d="M50 32 L56 33 L56 31 Z" fill="url(#legend-gold)" />
        
        <path d="M16 16 L20 20 L18 22 Z" fill="url(#legend-gold)" opacity="0.7" />
        <path d="M48 48 L44 44 L46 42 Z" fill="url(#legend-gold)" opacity="0.7" />
        <path d="M16 48 L20 44 L22 46 Z" fill="url(#legend-gold)" opacity="0.7" />
        <path d="M48 16 L44 20 L42 18 Z" fill="url(#legend-gold)" opacity="0.7" />
      </g>
      
      {/* Магические частицы */}
      <circle cx="18" cy="24" r="1.5" fill="#ffd200" opacity="0.8">
        <animate attributeName="opacity" values="0.3;0.9;0.3" dur="2s" repeatCount="indefinite" />
      </circle>
      <circle cx="46" cy="24" r="1.5" fill="#ffd200" opacity="0.8">
        <animate attributeName="opacity" values="0.9;0.3;0.9" dur="2s" repeatCount="indefinite" />
      </circle>
      <circle cx="18" cy="40" r="1.5" fill="#f7971e" opacity="0.8">
        <animate attributeName="opacity" values="0.5;0.9;0.5" dur="2.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="46" cy="40" r="1.5" fill="#f7971e" opacity="0.8">
        <animate attributeName="opacity" values="0.9;0.5;0.9" dur="2.5s" repeatCount="indefinite" />
      </circle>
      
      {/* Орбитальные элементы */}
      <circle cx="32" cy="18" r="2" fill="none" stroke="#ffd200" strokeWidth="1" opacity="0.5" />
      <circle cx="32" cy="46" r="2" fill="none" stroke="#ffd200" strokeWidth="1" opacity="0.5" />
    </svg>
  )
}
